import { api as apiKey } from "@polifonia/interlude/api/apiKey";
import { api as auth } from "@polifonia/interlude/api/auth";
import { api as balance } from "@polifonia/interlude/api/balance";
import { api as billing } from "@polifonia/interlude/api/billing";
import { api as channel } from "@polifonia/interlude/api/channel";
import { api as contract } from "@polifonia/interlude/api/contract";
import { api as customField } from "@polifonia/interlude/api/customField";
import { api as emailOnboard } from "@polifonia/interlude/api/emailOnboard";
import { api as googleAds } from "@polifonia/interlude/api/googleAds";
import { api as line } from "@polifonia/interlude/api/line";
import { api as lineAds } from "@polifonia/interlude/api/lineAds";
import { api as mcp } from "@polifonia/interlude/api/mcp";
import { api as metaAds } from "@polifonia/interlude/api/metaAds";
import { api as organization } from "@polifonia/interlude/api/organization";
import { api as productFeed } from "@polifonia/interlude/api/productFeed";
import { api as unifyScopeSetting } from "@polifonia/interlude/api/unifyScopeSetting";
import { api as uniqueContacts } from "@polifonia/interlude/api/uniqueContacts";
import { api as user } from "@polifonia/interlude/api/user";
import { generateApi } from "@polifonia/zodios/generateApi";
import type { InferFromModule } from "@polifonia/zodios/InferFromModule";
import { react } from "@polifonia/zodios/react";

import { interludeAxios } from "@/interlude/interludeAxios";

export type InterludeTypes = InferFromModule<
  typeof import("@polifonia/interlude/models")
>;

const api = generateApi({
  api: {
    apiKey,
    auth,
    balance,
    billing,
    channel,
    contract,
    emailOnboard,
    customField,
    googleAds,
    line,
    lineAds,
    mcp,
    metaAds,
    organization,
    productFeed,
    uniqueContacts,
    unifyScopeSetting,
    user,
  },
  zodiosOptions: {
    axiosInstance: interludeAxios,
  },
});

const hooks = react(api)();

export { hooks as interlude, api as interludeClient };
